/* eslint-disable */

/** unique or primary key constraints on table "argo.media_config" */
export enum ArgoMediaConfigConstraint {
  /** unique or primary key constraint on columns "id" */
  MediaPkey = 'media_pkey',
  /** unique or primary key constraint on columns "url" */
  MediaUrlKey = 'media_url_key'
}

/** select columns of table "argo.media_config" */
export enum ArgoMediaConfigSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  OriginalFileName = 'original_file_name',
  /** column name */
  SizeBytes = 'size_bytes',
  /** column name */
  Url = 'url'
}

/** update columns of table "argo.media_config" */
export enum ArgoMediaConfigUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  OriginalFileName = 'original_file_name',
  /** column name */
  SizeBytes = 'size_bytes',
  /** column name */
  Url = 'url'
}

